import { RootState } from "@react-three/fiber";
import { createEvent, createStore } from "effector";

export const setThree = createEvent<RootState>();
export const $three = createStore<RootState | null>(null).on(setThree, (_, three) => three);
